import { render, staticRenderFns } from "./mailInfo.vue?vue&type=template&id=cbb532e2&scoped=true&"
import script from "./mailInfo.vue?vue&type=script&lang=js&"
export * from "./mailInfo.vue?vue&type=script&lang=js&"
import style0 from "./mailInfo.vue?vue&type=style&index=0&id=cbb532e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb532e2",
  null
  
)

export default component.exports